import { connected, disconnected, messageReceived, errorOccurred } from '../slices/aviatorSocketSlice';

let activeAviatorSocket = null;

export const aviatorSocketMiddleware = (store) => (next) => (action) => {
  if (action.type === 'aviator/connect') {
    try {
      if (activeAviatorSocket) activeAviatorSocket.close();
      const endpoint = action.payload;
      activeAviatorSocket = new WebSocket(endpoint);

      activeAviatorSocket.onopen = () => store.dispatch(connected());
      activeAviatorSocket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          store.dispatch(messageReceived(data));
        } catch {
          store.dispatch(errorOccurred('Invalid JSON in socket message'));
        }
      };
      activeAviatorSocket.onerror = () => store.dispatch(errorOccurred('WebSocket error'));
      activeAviatorSocket.onclose = () => store.dispatch(disconnected());
    } catch {
      store.dispatch(errorOccurred('WebSocket init failed'));
    }
  }

  if (action.type === 'aviator/disconnect') {
    if (activeAviatorSocket) {
      activeAviatorSocket.close();
      activeAviatorSocket = null;
    }
  }

  if (action.type === 'aviator/send' && activeAviatorSocket?.readyState === WebSocket.OPEN) {
    const msg = typeof action.payload === 'string' ? action.payload : JSON.stringify(action.payload);
    activeAviatorSocket.send(msg);
  }

  return next(action);
};
